export default __webpack_public_path__ + "static/media/time-add-times.dac7eef0.png";